module.exports = __webpack_public_path__ + "img/1538334487.604ea350.jpg";